<template>

</template>

<script>
	import { Toast } from 'mint-ui';
export default {
	name: 'applypage',
	data() {
		return {
		}
	},

	mounted: function() {
        // http://m.tuanche.com/distributionPage/
		let url;
		let curUrl=window.location.href;
		let search=window.location.search;
		if(curUrl.indexOf("m.tuanche.com")!=-1){
            url="http://m.tuanche.com/distributionPage/"+search
		}else if(curUrl.indexOf("m.tuanche.com")!=-1){
            url="http://m.tuanche.com/distributionPage/"+search
		}else if(curUrl.indexOf("m.tuanche.com")!=-1){
            url="http://m.tuanche.com/distributionPage/"+search
		}
        window.location.href=url;
    }
}
</script>


// WEBPACK FOOTER //
// src/views/toutiao/applypage.vue